module.exports = __webpack_public_path__ + "media/images/element/online-0e9c2a05016eaba66f79e8c651d217f2.svg";